<template>
  <v-dialog v-model="showLocalDialog" max-width="490">
    <v-card :loading="runningTest" :disabled="runningTest">
      <v-overlay :opacity="0.9" absolute :value="showSuccessOverlay">
        <v-btn @click="showSuccessOverlay = false" color="success">
          Result: {{ formulaResponse }}
        </v-btn>
      </v-overlay>
      <v-overlay :opacity="0.9" absolute :value="showFailureOverlay">
        <v-btn @click="showFailureOverlay = false" color="error">
          {{ formulaResponse }}
        </v-btn>
      </v-overlay>
      <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
        Test Formula
        <v-spacer></v-spacer>

        <v-icon>mdi-play</v-icon>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-form>
          <v-autocomplete
            v-model="selectedUser"
            :items="admin.userList"
            item-text="name"
            item-value="value"
            label="User"
            @change="getSubsystems"
            required
          ></v-autocomplete>
          <v-autocomplete
            :loading="admin.subsystemByUserLoading"
            v-model="selectedSubsystem"
            :items="admin.subsystemByUserList"
            item-text="name"
            item-value="value"
            label="Subsystem"
            :disabled="!selectedUser"
            required
          ></v-autocomplete>
          <v-textarea
            outlined
            clearable
            auto-grow
            v-model="localFormula"
            label="Quantity Formula"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          @click="runTest"
          :loading="runningTest"
          :disabled="!selectedUser || !selectedSubsystem || runningTest"
          >Test</v-btn
        >
        <v-btn color="gray" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      showDialog: Boolean,
      formula: String
    },
    data() {
      return {
        showLocalDialog: this.showDialog,
        selectedUser: null,
        selectedSubsystem: null,
        runningTest: false,
        formulaResponse: null,
        showSuccessOverlay: false,
        showFailureOverlay: false,
        localFormula: null
      };
    },
    mounted() {
      this.localFormula = this.formula;
    },
    watch: {
      showDialog(val) {
        this.showLocalDialog = val;
      },
      showLocalDialog(val) {
        this.$emit('close', val);
      },
      /**
       * Pass formula changes to the parent
       * @param {*} val
       */
      localFormula(val) {
        this.$emit('updateFormula', val);
      },
      formula(val) {
        this.localFormula = val;
      }
    },
    methods: {
      /**
       * Gets subsystems for the selected user
       */
      getSubsystems() {
        this.$store.dispatch('admin/getSubsystemByUserList', this.selectedUser);
      },
      /**
       * Runs the test
       */
      runTest() {
        this.runningTest = true;
        this.$store
          .dispatch('admin/testQuantityFormula', {
            subsystemId: this.selectedSubsystem,
            formula: this.localFormula
          })
          .then((response) => {
            this.runningTest = false;
            if (response.success) {
              this.formulaResponse = response.response;
              this.showSuccessOverlay = true;
            } else {
              this.formulaResponse = response.response;
              this.showFailureOverlay = true;
            }
          });
      },
      /**
       * Closes this dialog
       */
      closeDialog() {
        this.showLocalDialog = false;
      }
    },
    computed: {
      ...mapState(['admin'])
    }
  };
</script>
